package com.evoapps.evoshift.data.dto.leave

import kotlinx.serialization.Serializable

/**
 * workplaces/{wpId}/leave_allowances/{userId}_{year} (SH-113): what a manager set for one
 * person's annual leave in one year. firestore.rules allows only these fields.
 */
@Serializable
data class LeaveAllowanceDto(
    val userId: String = "",
    val year: Int = 0,
    /** Null: the entitlement comes from the contract. */
    val entitlementDays: Int? = null,
    val carryOverDays: Int = 0,
    val updatedAt: String? = null,
    val updatedBy: String? = null
)
